import React, { useContext } from 'react';

import TableCell from '@mui/material/TableCell';

import Tooltip from '@mui/material/Tooltip';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';
import SchemaCompanyName from '../../../../../../components/_schema/SchemaCompanyName';
import { IDropshippingRequestCompanySchema } from '../../../../../../../graphql/type/dropshippingRequestCompany';
import useRoutes from '../../../../../../components/_hook/useRoutes';
import Moment from '../../../../../../components/Moment';
import CopyIconButton from '../../../../../../components/_iconButton/CopyIconButton';
import Context from '../../../../../../context';
import LabelDropshippingRequestCompanyStatus from '../../../../_module/LabelDropshippingRequestCompanyStatus';
import DROPSHIPPING_REQUEST_COMPANY from '../../../../../../components/constant/dropshippingRequestCompany';

interface IProps {
  item: IDropshippingRequestCompanySchema;
  setTableRefreshKey?: (tableRefreshKey: number) => void;
}

export default function DropshipperTableItem(props: IProps) {
  const { item, setTableRefreshKey } = props;
  const { path } = useRoutes();
  const { company } = useContext(Context);

  return (
    <>
      <TableCell align="left">
        <Tooltip title={item._id}>
          {item.status === DROPSHIPPING_REQUEST_COMPANY.STATUS.APPROVED ? (
            <Button
              color="primary"
              component={Link}
              to={path('product.dropshipping.dropshipper.approved.detail', {
                companyID: company._id,
                docID: item._id,
              })}
            >
              {item._id.substr(0, 6)}
            </Button>
          ) : (
            <>
              {item.status === DROPSHIPPING_REQUEST_COMPANY.STATUS.PENDING ? (
                <Button
                  color="primary"
                  component={Link}
                  to={path('product.dropshipping.dropshipper.pending.detail', {
                    companyID: company._id,
                    docID: item._id,
                  })}
                >
                  {item._id.substr(0, 6)}
                </Button>
              ) : (
                <span>{item._id.substr(0, 6)}</span>
              )}
            </>
          )}
        </Tooltip>
        <CopyIconButton iconHtmlFontSize="0.8rem" copyText={item._id} />
      </TableCell>
      <TableCell align="left">
        {item.fromCompanyData && (
          <SchemaCompanyName
            company={item.fromCompanyData}
            showExternalLink
            showVerification
          />
        )}
      </TableCell>
      <TableCell align="center">
        {item.fromCompanyData ? item.fromCompanyData.origin : null}
      </TableCell>
      <TableCell align="center">
        <LabelDropshippingRequestCompanyStatus status={item.status} />
      </TableCell>
      <TableCell align="center">
        {item.created && item.created.time && (
          <Moment time={item.created.time} />
        )}
      </TableCell>
    </>
  );
}
